<template>
    <div class="o-mainLayout">
        <Header 
            v-if="isLoggedIn" 
            :header-title="headerTitle" 
            :stepNumber="stepNumber" 
            :progress="progress"
            :is-module-started="isModuleStarted"
        />
        <div class="o-mainLayout__inner u-posRelative u-overflowHidden">
            <slot v-if="isLoggedIn"></slot>
        </div>
        <TabBar v-if="isLoggedIn" />
        <Loader v-else />
    </div>
</template>

<script setup>
import { watch } from 'vue';

// Components
import Header from '../organisms/Header.vue';
import TabBar from '../organisms/TabBar.vue';
import Loader from '../molecules/Loader.vue';

const props = defineProps({
    isLoggedIn: {
        type: Boolean,
        required: true
    },
    headerTitle: {
        type: String,
        default: ''
    },
    stepNumber: {
        type: Number,
        default: 0
    },
    progress: {
        type: Array,
        default: () => []
    },
    isModuleStarted: {
        type: Boolean,
        default: false
    }
});

watch(() => props.isLoggedIn, (newVal) => {
    if (!newVal) {
        window.location.href = '/login';
    }
});
</script>
